import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Empresa } from '../models/cadastro/empresa';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private empresas = [];
  usuarioEditando: any;

  menus = [
    {
      expanded: true,
      itemMenu: 'RECEBIVEIS',
      descricao: 'Recebíveis',
      class: 'faWallet',
      rota: '/recebiveis/dashboard',
      itens: [
        {
          expanded: true,
          itemMenu: 'RECEBIVEIS',
          descricao: 'Dashboard',
          rota: '/recebiveis/dashboard',
          itens: null,
          class: 'faChartLine',
        },
        {
          expanded: true,
          itemMenu: 'RECEBIVEIS',
          descricao: 'Lançamentos',
          rota: '/recebiveis/lancamentos',
          itens: null,
          class: 'faFileAlt',
        },
        {
          expanded: true,
          itemMenu: 'RECEBIVEIS',
          descricao: 'Conta gráfica',
          rota: '/recebiveis/conta-grafica',
          itens: null,
          class: 'faTasks',
        },
        {
          expanded: true,
          itemMenu: 'RECEBIVEIS',
          descricao: 'Arquivo de retorno',
          rota: '/recebiveis/arquivos-retorno',
          itens: null,
          class: 'faWallet',
        },
      ],
    },
    {
      expanded: true,
      itemMenu: 'OPERACIONAL',
      descricao: 'Operacional',
      class: 'faCalculator',
      rota: '/operacional/listagem',
      itens: [
        {
          expanded: true,
          itemMenu: 'OPERACIONAL',
          descricao: 'Operacional',
          rota: '/operacional/listagem',
          itens: null,
          class: 'faCalculator',
        },
      ],
    },
  ];

  menuSacado = [
    {
      expanded: true,
      itemMenu: 'RECEBIVEIS',
      descricao: 'Recebíveis',
      class: 'faWallet',
      rota: '/recebiveis/lancamentos',
      itens: [
        // {
        //   expanded: true,
        //   itemMenu: 'RECEBIVEIS',
        //   descricao: 'Dashboard',
        //   rota: '/recebiveis/dashboard',
        //   itens: null,
        //   class: 'faWallet',
        // },
        {
          expanded: true,
          itemMenu: 'RECEBIVEIS',
          descricao: 'Lançamentos',
          rota: '/recebiveis/lancamentos',
          itens: null,
          class: 'faWallet',
        },
      ],
    },
  ];

  menuInvestidor = [
    {
      expanded: true,
      itemMenu: 'INVESTIMENTOS',
      descricao: 'Meus investimentos',
      class: 'faChartLine',
      rota: '/investimento/meus-investimentos',
      itens: [
        {
          expanded: true,
          itemMenu: 'INVESTIMENTOS',
          descricao: 'Meus investimentos',
          rota: '/investimento/meus-investimentos',
          itens: null,
          class: 'faChartLine',
        },
        {
          expanded: true,
          itemMenu: 'INVESTIMENTOS',
          descricao: 'Posições',
          rota: '/investimento/posicoes',
          itens: null,
          class: 'faChartLine',
        },
      ],
    },
  ];

  constructor(private cookieService: CookieService) {}

  getTenantId(): string {
    return this.cookieService.check('tenant_id')
      ? this.cookieService.get('tenant_id')
      : '';
  }

  getEmpresaId(): string {
    return this.cookieService.check('empresa_id')
      ? this.cookieService.get('empresa_id')
      : '';
  }

  setTenantId(tenantId: string): void {
    this.cookieService.set('tenant_id', tenantId, 0, '/', '', false, 'Lax');
  }

  getEmpresas(): Empresa[] {
    return this.empresas;
  }

  setEmpresas(empresas: any) {
    this.empresas = empresas;
  }
}
